import { createContext, useContext, useState } from 'react';

const DevRoleOverrideContext = createContext();

export const DevRoleOverrideProvider = ({ children }) => {
  const [overrideRole, setOverrideRole] = useState(null);
  
  return (
    <DevRoleOverrideContext.Provider value={{ overrideRole, setOverrideRole }}>
      {children}
    </DevRoleOverrideContext.Provider>
  );
};

export const useDevRoleOverride = () => {
  const context = useContext(DevRoleOverrideContext);
  if (!context) {
    return { overrideRole: null, setOverrideRole: () => {} };
  }
  return context;
};

const RoleToggle = () => {
  const { overrideRole, setOverrideRole } = useDevRoleOverride();
  
  const roles = ['admin', 'manager', 'employee', 'viewer'];
  
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  
  return (
    <div style={{
      position: 'fixed',
      bottom: 20,
      right: 20,
      background: '#1a1a1a',
      color: 'white',
      padding: '10px',
      borderRadius: '8px',
      zIndex: 9999,
      fontSize: '12px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.3)'
    }}>
      <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>Dev Role Override</div>
      <select 
        value={overrideRole || ''} 
        onChange={(e) => setOverrideRole(e.target.value || null)}
        style={{
          background: '#333',
          color: 'white',
          border: '1px solid #555',
          padding: '4px 8px',
          borderRadius: '4px',
          width: '100%'
        }}
      >
        <option value="">No Override</option>
        {roles.map(role => (
          <option key={role} value={role}>{role}</option>
        ))}
      </select>
    </div>
  );
};

export default RoleToggle;